/**
 * 安全渲染运营粘贴的 SVG 矢量图标。
 * 仅允许 <svg> 根节点，剥离 <script>/<foreignObject> 与所有事件/on* 属性、
 * javascript: 协议，避免 XSS（SVG 由后台运营填写，仍需兜底防护）。
 */
function sanitize(raw: string): string {
  let s = raw.trim();
  if (!s.toLowerCase().startsWith('<svg')) return '';
  // 去除危险标签
  s = s.replace(/<\s*(script|foreignObject|iframe|object|embed)\b[^>]*>[\s\S]*?<\s*\/\s*\1\s*>/gi, '');
  // 去除事件处理器与 on* 属性
  s = s.replace(/\son\w+\s*=\s*"[^"]*"/gi, '');
  s = s.replace(/\son\w+\s*=\s*'[^']*'/gi, '');
  s = s.replace(/\son\w+\s*=\s*[^\s>]+/gi, '');
  // 去除 javascript: 协议
  s = s.replace(/(href|xlink:href)\s*=\s*("|')\s*javascript:[^"']*\2/gi, '$1=$2#$2');
  return s;
}

export function SvgIcon({
  code,
  className,
  size = 40,
}: {
  code: string | null | undefined;
  className?: string;
  size?: number;
}) {
  if (!code) return null;
  const clean = sanitize(code);
  if (!clean) return null;
  return (
    <span
      className={className}
      style={{ width: size, height: size, display: 'inline-flex' }}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}

// 缺省道具图标：统一的中式蜡烛矢量，避免依赖 emoji 占位
export const DEFAULT_PROP_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" fill="none" stroke="#6b4226" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="24" y="24" width="16" height="30" rx="2"/><path d="M32 24v-5"/><path d="M32 8c4 4 4 8 0 12-4-4-4-8 0-12z"/></svg>`;

/** 道具有 SVG 时显示 SVG，否则回退到统一的矢量图标（不再使用 emoji 占位） */
export function ProductIcon({
  iconSvg,
  size = 40,
  className,
}: {
  iconSvg?: string | null;
  size?: number;
  className?: string;
}) {
  return <SvgIcon code={iconSvg || DEFAULT_PROP_SVG} size={size} className={className} />;
}
